import { Pill } from '@/shared/components';
import type { PropertyLifecycleStatus } from '@/shared/api';

/** Wie die Status-Pill im ApartmentDetailLayout, hier mit "Aktiv" statt "● Live". */
export function ListStatusPill({ status }: { status: PropertyLifecycleStatus }) {
  switch (status) {
    case 'Active':
      return (
        <Pill variant="accent" size="sm">
          Aktiv
        </Pill>
      );
    case 'Paused':
      return (
        <Pill variant="warning" size="sm">
          Pausiert
        </Pill>
      );
    case 'Draft':
      return (
        <Pill variant="outline" size="sm">
          Entwurf
        </Pill>
      );
    case 'Archived':
      return (
        <Pill variant="default" size="sm">
          Archiviert
        </Pill>
      );
  }
}
